import truncate from 'lodash/truncate';
import { useState } from 'react';
import { Heading, InlineTextButton } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';
import classNames from 'classnames';
import css from './CustomExtendedDataSection.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;
const TEXT_COLLAPSED_LENGTH = 320;

const truncated = s => {
  return truncate(s, {
    length: TEXT_COLLAPSED_LENGTH,
    separator: /\s|,|\.|:|;/,
    omission: '…',
  });
};

const SectionText = props => {
  const {
    text,
    heading,
    headingClassName,
    className,
    rootClassName,
    showAsIngress = false,
    expandable = false,
  } = props;
  const [expand, setExpand] = useState(false);

  const textClass = showAsIngress ? css.ingress : css.text;

  const contentWithLinks = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const truncatedContent = richText(truncated(text), {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const handleShowMoreClick = () => {
    setExpand(true);
  };

  const handleShowLessClick = () => {
    setExpand(false);
  };

  const showMore = (
    <InlineTextButton
      style={{ fontWeight: 'var(--fontWeightHeavy)' }}
      onClick={handleShowMoreClick}
    >
      <FormattedMessage id="SectionTextMaybe.showMoreLink" style={{ font: '44px' }} />
    </InlineTextButton>
  );

  const showLess = (
    <InlineTextButton
      style={{ fontWeight: 'var(--fontWeightHeavy)' }}
      onClick={handleShowLessClick}
    >
      <FormattedMessage id="SectionTextMaybe.showLessLink" />
    </InlineTextButton>
  );

  // Use expandable logic if prop is true
  const content = expandable ? (expand ? contentWithLinks : truncatedContent) : contentWithLinks;

  const shouldShowMoreButton = expandable && text.length >= TEXT_COLLAPSED_LENGTH && !expand;
  const shouldShowLessButton = expandable && text.length >= TEXT_COLLAPSED_LENGTH && expand;

  const classes = classNames(rootClassName || css.sectionText, className);

  return text ? (
    <section className={classes}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading} className={headingClassName}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>
        {content}
        {shouldShowMoreButton ? showMore : null}
        {shouldShowLessButton ? showLess : null}
      </p>
    </section>
  ) : null;
};

export default SectionText;
